"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a, _b;
var types_1 = require("../../actions/internal/types");
var eventResults_1 = require("../../actions/internal/eventResults");
var eventResults_2 = require("../../actions/external/eventResults");
var types_2 = require("../../actions/external/types");
var meta_1 = require("../../actions/external/meta");
var meta_2 = require("../../actions/internal/meta");
var media_1 = require("../../actions/external/media");
var media_2 = require("../../actions/internal/media");
var eventSummary_1 = require("../../actions/internal/eventSummary");
var eventSummary_2 = require("../../actions/external/eventSummary");
var individualResults_1 = require("../../actions/external/individualResults");
var individualResults_2 = require("../../actions/internal/individualResults");
exports.externalToInternalTypeMap = (_a = {},
    _a[types_2.ResultActionTypes.GET_EVENT_RESULTS] = function (action) { return eventResults_1.getEventResultsInternal(action); },
    _a[types_2.ResultActionTypes.GET_EVENT_RESULTS_STOP] = function (action) { return eventResults_1.getEventResultsStopInternal(action); },
    _a[types_2.ResultActionTypes.GET_INDIVIDUAL_RESULTS] = function (action) { return individualResults_2.getIndividualResultsInternal(action); },
    _a[types_2.ResultActionTypes.GET_INDIVIDUAL_RESULTS_STOP] = function (action) {
        return individualResults_2.getIndividualResultsStopInternal(action);
    },
    _a[types_2.ResultActionTypes.GET_META] = function (action) { return meta_2.getMetaInternal(action); },
    _a[types_2.ResultActionTypes.GET_MEDIA] = function (action) { return media_2.getMediaInternal(action); },
    _a[types_2.ResultActionTypes.GET_MEDIA_STOP] = function (action) { return media_2.getMediaStopInternal(action); },
    _a[types_2.ResultActionTypes.GET_EVENT_SUMMARY] = function (action) { return eventSummary_1.getEventSummaryInternal(action); },
    _a['undefined'] = undefined,
    _a);
exports.internalToExternalTypeMap = (_b = {},
    _b[types_1.InternalClientActionType.GET_EVENT_RESULTS_DATA_STARTED_POLLING] = function (action) {
        return eventResults_2.getEventResultsSubscribed(action);
    },
    _b[types_1.InternalClientActionType.GET_EVENT_RESULTS_DATA_UPDATE] = function (action) {
        return eventResults_2.getEventResultsUpdate(action);
    },
    _b[types_1.InternalClientActionType.GET_EVENT_RESULTS_ERROR] = function (action) {
        return eventResults_2.getEventResultsError(action);
    },
    _b[types_1.InternalClientActionType.GET_META_DATA_COMPLETE] = function (action) {
        return meta_1.getMetaComplete(action);
    },
    _b[types_1.InternalClientActionType.GET_META_DATA_ERROR] = function (action) {
        return meta_1.getMetaError(action);
    },
    _b[types_1.InternalClientActionType.GET_EVENT_SUMMARY_COMPLETE] = function (action) {
        return eventSummary_2.getEventSummaryComplete(action);
    },
    _b[types_1.InternalClientActionType.GET_EVENT_SUMMARY_ERROR] = function (action) {
        return eventSummary_2.getEventSummaryError(action);
    },
    _b[types_1.InternalClientActionType.GET_INDIVIDUAL_RESULTS_DATA_STARTED_POLLING] = function (action) {
        return individualResults_1.getIndividualResultsSubscribed(action);
    },
    _b[types_1.InternalClientActionType.GET_INDIVIDUAL_RESULTS_DATA_UPDATE] = function (action) {
        return individualResults_1.getIndividualResultsUpdate(action);
    },
    _b[types_1.InternalClientActionType.GET_INDIVIDUAL_RESULTS_ERROR] = function (action) {
        return individualResults_1.getIndividualResultsError(action);
    },
    _b[types_1.InternalClientActionType.GET_MEDIA_DATA_STARTED_POLLING] = function (action) {
        return media_1.getMediaSubscribed(action);
    },
    _b[types_1.InternalClientActionType.GET_MEDIA_DATA_UPDATE] = function (action) {
        return media_1.getMediaUpdate(action);
    },
    _b[types_1.InternalClientActionType.GET_MEDIA_ERROR] = function (action) {
        return media_1.getMediaError(action);
    },
    _b['undefined'] = undefined,
    _b);
//# sourceMappingURL=actionMapper.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/reducers/external/actionMapper.js
 ** module id = 2083
 ** module chunks = 0
 **/